import "./priceTable.scss";

import { memo } from "react";

import type { PlaygroundModel } from "../../../../hooks/reactQueryHooks/usePlayground";
import type { ITokenUsageTiers } from "../../../../hooks/reactQueryHooks/useUsage";
import { formatCurrency } from "../../../../utils/NumbersFormatting";

interface IPriceTableProps {
  models?: PlaygroundModel[];
}

const PriceTable: React.FC<IPriceTableProps> = memo(({ models }) => {
  return (
    <table data-testid="price-table" className="price-table">
      <thead>
        <tr>
          <th>Model</th>
          <th>
            Input price
            <br />
            /1M tokens
          </th>
          <th>
            Output price
            <br />
            /1M tokens
          </th>
        </tr>
      </thead>
      <tbody>
        {models &&
          models.map(model => {
            return (
              <tr key={model.model}>
                <td>{model.displayName}</td>
                <td>{formatCurrency(model.inputTokensPrice * 1000)}</td>
                <td>{formatCurrency(model.outputTokensPrice * 1000)}</td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
});

export { PriceTable };
